import { css } from 'styled-components';
export default {
    gotham: {
        xlight: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 100;
    `,
        xlightItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 100;
      font-style: italic;
    `,
        thin: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 200;
    `,
        thinItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 200;
      font-style: italic;
    `,
        light: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 500;
      font-style: italic;
    `,
        bold: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
        black: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 800;
    `,
        blackItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 800;
      font-style: italic;
    `,
        ultra: css `
      font-family: 'Gotham', sans-serif;
      font-style: normal;
      font-weight: 900;
    `,
        ultraItalic: css `
      font-family: 'Gotham', sans-serif;
      font-weight: 900;
      font-style: italic;
    `,
    },
    plusJakarta: {
        thin: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 200;
    `,
        thinItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 200;
      font-style: italic;
    `,
        light: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 500;
      font-style: italic;
    `,
        semibold: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiboldItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 600;
      font-style: italic;
    `,
        bold: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
        black: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-style: normal;
      font-weight: 800;
    `,
        blackItalic: css `
      font-family: 'Plus Jakarta', sans-serif;
      font-weight: 800;
      font-style: italic;
    `,
    },
    neueGalano: {
        regular: css `
      font-family: 'Neue Galano', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        extraBold: css `
      font-family: 'Neue Galano', sans-serif;
      font-weight: 900;
      font-style: normal;
    `,
    }
};
